import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Conditions from './Conditions';
import AdvancedSwitch from '../AdvancedSwitch';
import InfoHover from '../../../../controls/InfoHover';

const styles = () => ({
    alignEnd: {
        textAlign: 'end',
    },
});

class RulesSection extends React.Component {
    state = {
        booleanOperator: 'all',
        conditions: [],
        advancedRequiredMsg: '',
        advancedMode: false,
        advancedVisibility: '',
    };

    componentDidMount() {
        this.setState({
            ...this.props.ruleData,
        });
    }

    handleChange = (event) => {
        const tag = event.target.id || event.target.name;
        const value = event.target.value || event.target.checked;
        const ruleData = {
            [tag]: value,
        };
        this.handleUpdateVisibility(ruleData);
    };

    toggleAdvanced = () => {
        if (!this.state.advancedMode) {
            const jsonConditions = {
                [this.state.booleanOperator]: this.state.conditions,
            };
            const jsonConditionsString = JSON.stringify(jsonConditions);
            const newVisibility = {
                ...this.state,
                advancedMode: !this.state.advancedMode,
                advancedVisibility: jsonConditionsString,
            };
            this.handleUpdateVisibility(newVisibility);
        } else {
            try {
                let newVisibility = {};
                if (this.state.advancedVisibility) {
                    let advancedConditionsJson = JSON.parse(this.state.advancedVisibility);
                    let booleanOperator = advancedConditionsJson.any ? 'any' : 'all';
                    let nonAdvanced = {
                        booleanOperator,
                        conditions: advancedConditionsJson[booleanOperator],
                    };
                    newVisibility = {
                        ...nonAdvanced,
                    };
                }
                newVisibility.advancedMode = !this.state.advancedMode;
                this.handleUpdateVisibility(newVisibility);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        }
    };

    handleUpdateVisibility = (ruleData) => {
        this.setState(
            {
                ...ruleData,
            },
            () => {
                this.props.handleChange({ visibility: this.state });
            },
        );
    };

    render() {
        return (
            <React.Fragment>
                <Grid container spacing={2} item justifyContent="space-between">
                    <Grid item xs={6}>
                        <Typography variant="h6" gutterBottom>
                            Conditions
                            <InfoHover
                                text={
                                    'Add conditions to show or hide this field based on answers given for other fields.'
                                }
                            />
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={this.props.classes.alignEnd}>
                        <AdvancedSwitch
                            checked={this.state.advancedMode}
                            onToggle={this.toggleAdvanced}
                            advancedRequiredMsg={this.state.advancedRequiredMsg}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Conditions
                            entries={this.props.entries}
                            conditions={this.state.conditions}
                            operator={this.state.booleanOperator}
                            advancedMode={this.state.advancedMode}
                            advancedVisibility={this.state.advancedVisibility}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(RulesSection);
